// @flow
import { getJson } from 'utils/http';

export const waitTaskCompleted = (
  taskUrl: string,
  timeout: number = 240000
): Promise<BackgroundTaskResult> =>
  new Promise((resolve, reject) => {
    const WAIT_MS = 500;
    const checkTask = () => {
      getJson(taskUrl)
        .then(({ task }) => {
          if (task.status === 'COMPLETED') {
            resolve(task.result);
          } else {
            timeout -= WAIT_MS;
            if (timeout < 0) {
              reject(new Error('Request timed out'));
            } else {
              setTimeout(checkTask, WAIT_MS);
            }
          }
        })
        .catch(() => {
          reject(new Error('Request failed'));
        });
    };
    checkTask();
  });
